export const attributeNames = {
  address1: 'address',
  address2: 'address2',
  city: 'city',
  zip: 'zip',
  country: 'country',
  latitude: 'latitude',
  longitude: 'longitude'
}
